export default function (pathToSearchResults) {
  return window.location.pathname === pathToSearchResults && window.location.search.length > 0;
}
